module.exports = __webpack_public_path__ + "static/savings-255cbba4e5b5c62efc0fea75e517f0a1.png";